import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalInformationDTO } from 'src/app/models/modal-information-dto';

@Component({
  standalone: false,
  selector: 'app-information-modal',
  templateUrl: './information-modal.component.html',
  styleUrls: ['./information-modal.component.scss']
})
export class InformationModalComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ModalInformationDTO,
  private dialogRef: MatDialogRef<InformationModalComponent>) { }


  closeModal(): void {
    this.dialogRef.close();
  }

}
